import React from "react";

const Card = ({ children, className = "" }) => {
  return (
    <div
      className={`bg-surface border border-border rounded-lg p-6 shadow-lg card-glow card-glow-hover ${className}`}
    >
      {children}
    </div>
  );
};

export default Card;
